module.exports = __webpack_public_path__ + "static/media/Risk-Exclamation-Plus.af42cf15.png";